import React, { useEffect, useState } from 'react'
import { Stepper, Step, StepLabel, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OfficialDetails from './BankDetails';
import { Tooltip } from 'antd';
// import Step from '@material-ui/core/Step';
// import StepLabel from '@material-ui/core/StepLabel';
// import StepConnector from '@material-ui/core/StepConnector';
import Cookies from 'js-cookie';
import CompanyDetails from './CompanyDetails';
import BankDetails from './BankDetails';
import Documentation from './Documentation';
import Declaration from './Declaration';
import Contract from './Contract';
import { getCustomerUpdateProfileData } from '../../Redux/action/Admin/CustomerAction';
import { useDispatch, useSelector } from 'react-redux';

const EmployeeRegistration = ({ }) => {

    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const dispatch = useDispatch()


    const handleNext = () => {
        window.scroll(0, 0);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        window.scroll(0, 0);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const customertoken = Cookies.get('customertoken');

    useEffect(() => {
        refresh();
    }, [])

    const refresh = () => {
        if (customertoken) {
            dispatch(getCustomerUpdateProfileData(customertoken));
        }
    }

    let {
        loadingCustomerUpdateProfileDataApi, CustomerUpdateProfileDataError, CustomerUpdateProfileData,
    } = useSelector(state => state?.CustomerReducer);



    const steps = [
        {
            content: (<>
                <CompanyDetails handleNext={handleNext} handleBack={handleBack} activeStep={activeStep} CustomerProfileData={CustomerUpdateProfileData} refresh={refresh} />
            </>
            ),
        },
        {
            // label: 'Bank Details',
            content: (<>
                <BankDetails handleNext={handleNext} handleBack={handleBack} activeStep={activeStep} CustomerProfileData={CustomerUpdateProfileData} refresh={refresh} />
            </>),
        },
        {
            // label: 'Documentation',
            content: (<>
                <Documentation handleNext={handleNext} handleBack={handleBack} activeStep={activeStep} CustomerProfileData={CustomerUpdateProfileData} refresh={refresh} />
            </>),
        },
        {
            // label: 'Declaration',
            content: (<>
                <Declaration handleNext={handleNext} handleBack={handleBack} activeStep={activeStep} CustomerProfileData={CustomerUpdateProfileData} refresh={refresh} />
            </>),
        },
    ];

    const stepIcons = [
        <Tooltip placement="bottom" title="Company Details">
            <div className="registration-icon-box">
                <div
                    className="step-icon-registration"
                >
                    <i className="fa-regular fa-building"></i>
                </div>

            </div>
        </Tooltip>
        ,  // Replace with your icons
        <Tooltip placement="bottom" title="Bank Details">
            <div className="registration-icon-box">

                {/* <Button>Bottom</Button> */}
                <div
                    className="step-icon-registration"
                >
                    <i className="fa-solid fa-building-columns"></i>
                </div>
            </div>
        </Tooltip>
        ,
        <Tooltip placement="bottom" title="Documentation">
            <div className="registration-icon-box">

                <div
                    className="step-icon-registration"
                >
                    <i className="fa-regular fa-file"></i></div>
            </div>
        </Tooltip>
        ,
        <Tooltip placement="bottom" title="Declaration">
            <div className="registration-icon-box">
                <div
                    className="step-icon-registration"
                >
                    <i className="fa-solid fa-list-check"></i></div>

            </div>
        </Tooltip>
        ,
        <Tooltip placement="bottom" title="Agreement">
            <div className="registration-icon-box">
                <div
                    className="step-icon-registration"
                >
                    <i className="fa-regular fa-handshake"></i>
                </div>
            </div>
        </Tooltip>
    ];

    const handleReset = () => {
        setActiveStep(0);

    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="container">
                    <div className="card">
                        <div className="card-body">
                            <section>
                                <div className="col-md-12">
                                    <div className="query_bg_info_kyc">
                                        <div className="main_section_detail">
                                            <div className='count-step  custom-resume-stepper d-flex flex-col align-items-center justify-content-center' >
                                                <div className=' w-100 overflow-auto d-lg-flex justify-content-center'>

                                                    <Stepper className='employee-registration-class border-bottom w-100 align-items-center custom-emp-stepper' activeStep={activeStep}
                                                        alternativeLabel // Horizontal layout
                                                    >
                                                        {steps.map((step, index) => (
                                                            <Step key={index} className='custom-step custom-regitration-stepper-box' >
                                                                <StepLabel icon={stepIcons[index]} // Custom icon
                                                                    StepIconComponent={null} style={{ display: 'grid', justifyItems: 'center' }}>{step.label}</StepLabel>
                                                            </Step>
                                                        ))}
                                                    </Stepper>
                                                </div>
                                            </div>
                                            <div className='overflow-auto' >


                                                {steps[activeStep] && (
                                                    <Paper className='h-100 d-flex flex-col justify-content-between' square elevation={0} sx={{ p: 3 }}>
                                                        <div className='w-100'>

                                                            <div>{steps[activeStep].content}</div>

                                                        </div>

                                                    </Paper>
                                                )}

                                                {activeStep === steps.length && (

                                                    <div className='w-100 text-center my-5'>
                                                        <img src="/img/like.gif" width={100} alt="" srcset="" />
                                                        <h5>Profile updated! Your data is sent to admin for review and approval.</h5>

                                                    </div>

                                                )}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default EmployeeRegistration